var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJockeyChallenge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "38px",
    viewBox: "0 0 37 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jockey_challenge",
    transform: "translate(0.856444, 0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5487587,17.7790285 C13.0893223,17.9905022 15.2727686,18.2791427 17.1091038,18.649605 C20.1192609,19.1806207 23.0367014,19.9230864 25.4957061,20.9619219 C29.6938662,22.7339764 32.9263487,24.6449296 35.2359846,26.2380952 C36.5013354,21.9344101 38.7635333,3.68632698 23.3023258,1.66864117 C23.028164,0.702356981 22.2436436,0 21.3058602,0 C20.414471,0 19.6580895,0.632887893 19.3487704,1.52507963 C12.4976063,1.96038764 8.95162947,6.32271444 7.20131631,13.8335162 C1.72260275,15.4213111 -0.629984173,16.6793404 0.143555525,17.6076043 C1.30386507,19 4.92659306,17.3992207 8.10400712,17.6076043 C8.91081403,17.654 9.73047024,17.7095673 10.5487587,17.7790285 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8877415,28.047619 C18.6495699,27.6622403 22.8668444,26.4070992 22.7456486,23.2249234 C22.7074061,22.2133482 21.2910971,21.416483 19.0611628,20.8095238 L16.8877415,28.047619 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0717777,20.5027502 C14.768019,19.3673179 13.4764228,19 8.96711867,18.5370612 L8.96711867,19 L6.91400335,23.3759017 C6.86501959,23.4966144 6.84122994,23.6356653 6.84122994,23.7777556 C6.84122994,24.3492228 7.26389042,24.8122172 7.78869595,24.8122172 L9.36734021,24.8122172 L9.36734021,28.4046097 C9.36734021,31.2054992 11.4428443,33.4761905 14.0052481,33.4761905 L14.481077,33.4761905 L18.0717777,20.5027502 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2365788,28.9522686 L33.6319276,27.2429125 C31.3847444,25.9116609 28.387959,24.3765106 24.6259255,22.9561078 C24.3174571,22.839979 24.0003467,22.7266818 23.6774649,22.6190476 C23.9138587,22.9886685 24.0392659,23.3809851 24.0565466,23.8001667 C24.1617728,26.3946552 22.2605122,27.9908953 20.2365788,28.952381 L20.2365788,28.9522686 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.3390225 30.5706667 15.2133229 34.2606853 15.2133229 38 28.6086718 38 28.6086718 31.5437476 28.6057703 28.952381z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJockeyChallenge);
export default ForwardRef;